<template>
  <div id="app">
    <layou-header />
    <div class="main">
      <layou-sidebar />
      <div class="page">
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layouHeader from "@/layou/header.vue";
import layouSidebar from "@/layou/sidebar.vue";
export default {
  name: "App",
  components: { layouHeader, layouSidebar }
};
</script>

<style>
#app {
  padding-top: 61px;
}

.main {
  position: relative;
  z-index: 1;
  padding: 0 0 30px;
  overflow-x: hidden;
}

.page {
}
.content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-size: 1.2rem;
}
@media (min-width: 768px) {
  .main {
    padding: 0 60px 30px;
  }
  .page {
    padding-left: 14rem;
  }
  .content {
    padding: 2rem;
  }
}
@media (min-width: 992px) {
  .page {
    padding-left: 16rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue